import type { Actor } from './activity'

export type Change = { field: string; from: string; to: string; note?: string }

/**
 * The document written for one change, with nothing undefined in it.
 *
 * Firestore rejects `undefined` outright and fails the whole write — which surfaces as a
 * red error on a screen where somebody was only answering a question. The trap is an
 * optional field written as `note: text || undefined`, which reads as "leave it out" and
 * does not: the key is still there, holding undefined.
 *
 * So the payload is built rather than spread, and every optional part is either present
 * with a value or absent. `byName` is null rather than absent because the change log reads
 * it directly, and null is a value Firestore is happy to store.
 */
export function changePayload(
  change: Change, actor: Actor,
): Record<string, unknown> {
  const note = (change.note ?? '').trim()
  return {
    field: change.field,
    from: change.from,
    to: change.to,
    ...(note === '' ? {} : { note }),
    byEmail: actor.email,
    byName: actor.name ?? null,
  }
}
